module.exports = Dropzone;


//////////////////
// WEBPACK FOOTER
// external "Dropzone"
// module id = 520
// module chunks = 0